// Bridge page: Valida (o testing_url) vuelve acá y redirige al flujo mobile correcto.
// Configurada vía COMMERCE_MOBILE_IDENTITY_CALLBACK_URL / VALIDA_REDIRECT_URL en lenders_backoffice.

import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faIdCard } from '@fortawesome/free-solid-svg-icons';

const ORIGINAL_TOKEN_KEY = 'temp_originalToken';
const TOKEN_TYPE_KEY = 'temp_tokenType';
const SIGNATURE_TOKEN_TYPE = 'commerce_mobile_signature';

const MobileIdentityCallbackPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    const fromStep = searchParams.get('from_step') || 'identity_validation';
    const originalToken = localStorage.getItem(ORIGINAL_TOKEN_KEY);
    const tokenType = localStorage.getItem(TOKEN_TYPE_KEY);

    if (!originalToken) {
      console.error('MobileIdentityCallbackPage: falta token', { fromStep, tokenType });
      setError('No se pudo retomar el proceso. Pedile a tu vendedor un nuevo enlace para continuar.');
      return;
    }

    if (tokenType === SIGNATURE_TOKEN_TYPE) {
      navigate(`/m/signature/${originalToken}?from_step=${fromStep}`, { replace: true });
      return;
    }

    navigate(`/m/onboarding/${originalToken}/flow?from_step=${fromStep}`, { replace: true });
  }, [navigate, searchParams]);

  if (error) {
    return (
      <div className="container-fluid vh-100 d-flex align-items-center justify-content-center">
        <div className="text-center px-3">
          <FontAwesomeIcon icon={faExclamationCircle} size="3x" className="text-danger mb-3" />
          <h4>Atención</h4>
          <p className="text-muted">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid vh-100 d-flex align-items-center justify-content-center">
      <div className="text-center">
        <FontAwesomeIcon icon={faIdCard} size="3x" className="text-primary mb-3" />
        <div className="spinner-border text-primary mb-3 d-block mx-auto" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
        <p className="text-muted">Verificando identidad...</p>
      </div>
    </div>
  );
};

export default MobileIdentityCallbackPage;
